/* global $ */
var Proj = (function(proj){
    'use strict';

    proj.Underlay = function(){
        var $items_wrap = $('.js-underlay');
        var $items = $('.js-underlay__item');
        var $underlay = $('.js-underlay__underlay');
        var $hovered;

        $items.removeClass('m--js-none');

        $items.mouseenter(function(){
            if ($underlay.css('display') != 'none') {
                $hovered = $(this);
                $items.removeClass('m--active')
                $hovered.addClass('m--active');
                $underlay.stop( true, true );
                $underlay.animate({
                    top: $hovered.position().top,
                    left: $hovered.position().left,
                    width: $hovered.outerWidth(),
                    height: $hovered.outerHeight(),
                    opacity: 1
                },150);
            }
        });

        $items_wrap.mouseleave(function(){
            if ($underlay.css('display') != 'none' || $hovered.hasClass('m--active')) {
                $hovered.removeClass('m--active');
                $underlay.animate({
                    opacity: 0
                },150);
            }
        });
    };

    return proj;
})(Proj || {});



